export const thymeleafVariableRegex = /\[\s*\(\s*\$\s*\{\s*(\w+)\s*\}\s*\)\s*\]/g;

export const replaceVariables = (text: string, variables: { variableName: string; variableValue: string }[]) => {
  if (!text || !variables || variables.length === 0) return text;
  const variableMap = new Map(variables.map((x) => [x.variableName, x.variableValue]));
  return text.replaceAll(thymeleafVariableRegex, (match, captureGroup) => {
    return variableMap.get(captureGroup) ?? match;
  });
};
